var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"content",staticClass:"latex-renderer",domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }